import { headlineActions } from '../actions';

export default function headline ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case headlineActions.SET_HEADLINE: return generalHeadlineReducer( newState, action );
        case headlineActions.GENERAL_HEADLINE_REQUEST: return generalHeadlineReducer( newState, action );
        case headlineActions.GENERAL_HEADLINE_SUCCESS: return generalHeadlineReducer( newState, action );
        case headlineActions.GENERAL_HEADLINE_ERROR: return generalHeadlineReducer( newState, action );
        default: return newState;
    }
}

function generalHeadlineReducer ( newState, action ) {
    delete action.type;
    return Object.assign( newState, { ...action } );
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/headline.js